<template>
  <div v-if="shouldShow" :class="$style['drawer']">
    <div
      :class="$style['drawer__bg']"
      @click="closeDrawer" />

    <div
      ref="wrapper"
      :class="$style['drawer__wrapper']">
      <div :class="$style['drawer__toolbar']">
        <Btn
          color="white"
          compact
          role="button"
          aria-label="Select language"
          tab-index="0"
          :class="[$attrs.class]"
          @click="rootStore.toggleLanguageSwitcher()">
          <img
            :class="$style['image']"
            width="30"
            height="22.5"
            :alt="$lang"
            :src="languageImagePath($lang)">
        </Btn>

        <btn
          v-if="!rootStore.loginDisabled"
          color="white"
          compact
          :to="{ name: `${$lang}-account` }"
          @click="closeDrawer">
          <Badge
            v-if="unreadNotifications === 0"
            :color="loggedIn ? 'success' : 'fail'"
            :icon="!loggedIn ? 'System/close-line' : 'System/check-line' "
            size="small">
            <SvgIcon name="User/account-circle-line" />
          </Badge>
          <Badge
            v-if="unreadNotifications > 0"
            size="small"
            :text="unreadNotifications">
            <SvgIcon name="User/account-circle-line" />
          </Badge>
        </btn>

        <Btn
          class="h-margin-left-auto"
          size="small"
          border
          color="white"
          @click="closeDrawer">
          {{ $t('general/close') }}
        </Btn>
      </div>

      <div :class="$style['drawer__content']">
        <LegacyDrawerNavigation @show-sub-navigation="$event=> setSubNavigation($event)" />
        <LegacyDrawerServiceMobileNavigation
          class="h-margin-top-xl"
          :class="[
            $style['drawer__content__service'],
            { [$style['drawer__content__service--down']]: subNavigation }]" />
      </div>
    </div>
  </div>
</template>
<script setup>
const authStore = useAuthStore()
const rootStore = useRootStore()
const { shouldShow, closeDrawer } = useDrawer()
const { notifications } = useNotifications()
const unreadNotifications = ref(0)

const subNavigation = ref(null)
const wrapper = ref()

const loggedIn = computed(() => authStore.loggedIn)

const languageImagePath = lang => {
  return '/flags/' + (lang === 'en' ? 'eu' : lang) + '.svg'
}

watch(notifications, () => {
  unreadNotifications.value = 0
  if (loggedIn.value) {
    notifications.value.forEach(notification => {
      if (!notification.readAt) {
        unreadNotifications.value++
      }
    })
  }
})

onMounted(async () => {
  await nextTick()
  await useI18n(['footer'])
})

const setSubNavigation = $event => {
  subNavigation.value = $event
  if (!wrapper.value) { return }
  wrapper.value.scrollTop = 0
}

</script>
<style lang="scss" module>
.drawer {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  bottom: 0;
  height: auto;
  width: 100%;
  z-index: var(--z-index-drawer);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media screen and (prefers-color-scheme: darker) {
    background-color: var(--grey-darkest);
    color: var(--grey-dark);
  }

  &__bg {
    background-color: transparent;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &__content{
    position: relative;
  }

  &__wrapper {
    background-color: var(--white);
    box-shadow: 0 50px 500px 100px var(--black-20-opacity);
    height: 100%;
    max-width: 600px;
    overflow-y: scroll;
    overflow-x: hidden;
    overscroll-behavior: none;
    position: relative;
    width: calc(100% - #{calc(var(--spacing) * 4)});
    z-index: 2;
  }

  &__toolbar {
    background-color: var(--white);
    box-shadow: var(--box-shadow-large);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: calc(env(safe-area-inset-top) + var(--toolbar-height));
    padding: 0 var(--spacing);
    padding-top: env(safe-area-inset-top);
    width: 100%;
  }
}
</style>
